import React from 'react';
import { observer } from 'mobx-react-lite';
import styles from './pricepanel.module.sass';
import { Text } from '../../Text';
import { formatter } from '../../../utils/formatter';
import { Button } from '../../Button';
import {
  useCruizStore,
  useFavorites,
  useSeaCruiseStore,
  useDiscountStore,
} from '../../../providers/RootStoreProvider';
import { isClient } from '../../../utils/isClient';
import { declOfNum } from '../../../utils/declOfNum';
import { SeaRequestMini } from '../../seaRequestMini';
import { Icon } from '../../Icon';
import { YaAndGaCruisePage, YaAndGaShipPage } from '../../../lib/YaAndGaHelper';
import { TooltipDiscount } from '../../TooltipDiscount';
import { IconSVG } from '../../SpriteSVG';
import { Informer } from '../../Informer';
import { yandexDataLayer } from '../../../lib/yandexDataLayer';
import { sendVKPixelEvent } from '../../../lib/sendVKPixelEvent';

export const PricePanel = observer(
  ({
    cruizDetail,
    price,
    onChoose,
    priceDiscounted,
    elRef,
    data,
    cashback,
    isShips,
    isSea,
    titleShip,
    cruiseDateS,
    cruiseDateE,
    cruiseDays,
    isSpecialOffer,
    users,
    ownerId,
    specialOfferValue,
    isDisabledOnlinePay,
    isMobile,
    blackFriday,
    shipId,
  }) => {
    const store = useFavorites();
    const cruiseStore = useCruizStore();
    const seaStore = useSeaCruiseStore();
    const discountStore = useDiscountStore();
    const isEarlyBooking = priceDiscounted !== 0;
    const isFavorite = store.checkById(data?.id);
    const isZero = price - priceDiscounted === 0;

    const isFunSun = () => cruiseStore.isFunSun() || ownerId === 100025;

    const { discounts, rb, isDiscounts } = discountStore;
    const toggleFavorite = () => {
      store.toggle(data);
    };

    return (
      <div className={styles.price} ref={elRef}>
        {price !== '0' && price !== 0 ? (
          <div className={styles.priceWrapper}>
            <div className={styles.priceOld}>
              {price && (
                <span>
                  <Text variant="heading-4">
                    {price > 200 &&
                      `от ${formatter(
                        isEarlyBooking ? priceDiscounted : price,
                      )} ₽
                    ${isFunSun() ? '' : '/ чел.'}`}
                  </Text>
                </span>
              )}
              {price !== priceDiscounted && (
                <div className={styles.priceOldContent}>
                  <span className={styles.priceOldRed}>
                    от {formatter(isEarlyBooking && price)} ₽
                  </span>
                </div>
              )}
            </div>
            {(isSpecialOffer && rb?.days_before_rise) ||
              (shipId === 209 && (
                <div className={styles.specialOffer}>
                  <div className={styles.specialOfferDescription}>
                    {blackFriday ? (
                      <Text variant="heading-4">
                        <div className={styles.textWrapper}>
                          <Text>Цена указана с учетом примененной скидки.</Text>
                        </div>
                      </Text>
                    ) : (
                      <>
                        <Icon
                          icon={
                            <IconSVG
                              name={'promo/present'}
                              width={18}
                              height={19}
                            />
                          }
                        />
                        <Text>
                          Действует спецпредложение{' '}
                          {specialOfferValue !== null && (
                            <span>-{specialOfferValue}%</span>
                          )}
                        </Text>
                      </>
                    )}
                  </div>
                  {!blackFriday && (
                    <div>
                      <Text variant={'text-3'} size={'sm'}>
                        Цена указана со скидкой
                      </Text>
                    </div>
                  )}
                </div>
              ))}
            {rb?.days_before_rise && price !== priceDiscounted && (
              <Text variant="heading-4">
                <div className={styles.textWrapper}>
                  <Text>Указана цена со скидкой раннего бронирования.</Text>
                </div>
              </Text>
            )}
          </div>
        ) : (
          ''
        )}
        {isEarlyBooking && !isZero && !blackFriday && (
          <div className={styles.priceGroup}>
            {rb?.days_before_rise && <Text>Дороже на</Text>}
            {rb?.days_before_rise && (
              <Text variant="text-4" color="red2">
                {formatter(parseInt(price, 10) - parseInt(priceDiscounted, 10))}{' '}
                ₽{'    '}
              </Text>
            )}
            {'      '}
            {rb?.days_before_rise && <Text> через </Text>}
            <Text variant="text-4">
              {rb?.days_before_rise && rb?.days_before_rise}{' '}
              {rb?.days_before_rise &&
                declOfNum(rb?.days_before_rise, ['день', 'дня', 'дней'])}
            </Text>
          </div>
        )}
        <div className={styles.pickWrapper}>
          {!isSea && (
            <Button
              size="semi-lg"
              fullWidth
              background="primary"
              onClick={() => {
                onChoose();
                if (!isShips) {
                  YaAndGaCruisePage('click_choose_of_cabin_cruise_page');
                }
              }}
            >
              {isShips ? 'Выбрать круиз' : 'Выбрать каюту'}
            </Button>
          )}
          {(seaStore.available !== 0 && seaStore.outputTree.length !== 0) ||
          seaStore.loadingCabin ? (
            <Button
              size="semi-lg"
              fullWidth
              background="primary"
              onClick={onChoose}
            >
              {isShips ? 'Выбрать круиз' : 'Выбрать каюту'}
            </Button>
          ) : (
            isSea &&
            seaStore.isMSC && (
              <SeaRequestMini
                title={titleShip}
                onChoose={onChoose}
                isShips={isShips}
                cruiseDateS={cruiseDateS}
                cruiseDateE={cruiseDateE}
                cruiseDays={cruiseDays}
                users={users}
                isMobile={isMobile}
              />
            )
          )}
        </div>
        {!isShips && isClient && (
          <button
            className={styles.heartBtn}
            onClick={() => {
              toggleFavorite();
              if (!isFavorite) {
                YaAndGaCruisePage('click_add_to_basket_cruise_page');
                yandexDataLayer('add', { ...cruizDetail, quantity: 1 });
                sendVKPixelEvent("AddToCart", { product_id: cruizDetail.id, value: cruizDetail.price });
              } else {
                yandexDataLayer('remove', { ...cruizDetail, quantity: 1 });
              }
            }}
          >
            <div>
              {!isFavorite ? (
                <Icon
                  icon={<IconSVG name={'common/cart'} width={20} height={20} />}
                />
              ) : (
                <Icon
                  icon={
                    <IconSVG
                      name={'common/cart-active'}
                      width={20}
                      height={20}
                    />
                  }
                />
              )}
            </div>
            {/* <img src={!isFavorite ? CartIcon : CartActiveIcon} alt="" /> */}
            <span>{!isFavorite ? 'Добавить в корзину' : 'В корзине'}</span>
          </button>
        )}
        <div className={styles.pickPriceBlock}>
          {/* информационная плашка о том, что круиз оплачивается после согласования с менеджером */}
          {isDisabledOnlinePay && <Informer />}

          {!isSea && isDiscounts && (
            <div>
              {cashback === 1 && (
                <div className={styles.pickPrice}>
                  <div className={styles.cashbackAll}>
                    <Icon
                      icon={
                        <IconSVG
                          name={'promo/cashback'}
                          width={24}
                          height={24}
                        />
                      }
                      rightGap={8}
                      title="Иконка кэшбека"
                    />
                    <div className={styles.cashback}>
                      <div className={styles.cashback}>
                        <span>Кэшбэк 20% при оплате картой МИР</span>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              <div className={styles.pickPrice}>
                {discounts.map((i, ind) => (
                  <div key={ind}>
                    {/* <div className={styles.priceTextSale}>
                <Text></Text>
                <Icon rightGap={8} icon={sale} title="Скидка" />
                <Text variant="text-4" colorText="green">
                  Скидки
                </Text>
                </div> */}

                    <div className={styles.priceTextSalePercent}>
                      <div className={styles.priceTextSale}>
                        <Text variant="text-3" colorText="white">
                          <span>-{Object.keys(i).join()}% </span>
                        </Text>
                      </div>
                      <div className={styles.priseTextOut}>
                        {price !== 0 && (
                          <Text variant="text-4">
                            от{' '}
                            {Object.values(i)[0][0].price
                              ? formatter(Object.values(i)[0][0].price)
                              : formatter(
                                  Math.floor(
                                    parseInt(price, 10) -
                                      parseInt(price, 10) *
                                        (Object.keys(i) / 100),
                                  ),
                                )}{' '}
                            ₽{isFunSun() ? '' : '/чел.'}
                          </Text>
                        )}
                      </div>
                    </div>
                    <div
                      className={
                        ind + 1 === discounts.length
                          ? styles.panelDiscountForTextTwo
                          : styles.panelDiscountForText
                      }
                    >
                      <Text>
                        {Object.values(i)[0].map((item, id) => (
                          <div className={styles.tooltipBlock}>
                            {id === 0 ? (
                              item.description !== '' ? (
                                <TooltipDiscount
                                  trigger={
                                    <div>
                                      {item.alias.replace('Скидка', '')}
                                      {Object.values(i)[0].length === 1
                                        ? ''
                                        : '; '}
                                    </div>
                                  }
                                  content={<div>{item.description}</div>}
                                />
                              ) : (
                                <div>{item.alias.replace('Скидка', '')}</div>
                              )
                            ) : item.description !== '' ? (
                              <TooltipDiscount
                                trigger={
                                  <div>
                                    {item.alias.replace('Скидка', '')}
                                    {id + 1 === Object.values(i)[0].length
                                      ? ''
                                      : '; '}
                                  </div>
                                }
                                content={<div>{item.description}</div>}
                              />
                            ) : (
                              <div>{item.alias.replace('Скидка', '')}</div>
                            )}
                          </div>
                        ))}
                      </Text>
                    </div>
                  </div>
                ))}
              </div>
              {/* <div className={styles.pickPrice}>
              <div className={styles.cashbackAll}>
                <Icon
                  icon={promoIcon}
                  rightGap={8}
                  width={24}
                  height={24}
                  title="Иконка"
                />
                <div className={styles.cashback}>
                  <div className={styles.cashback}>
                    <span>-50% за одноместное размещение</span>
                  </div>
                </div>
              </div>
            </div> */}
              <div className={styles.sumSales}>
                {!isSea && isDiscounts && 'Скидки не суммируются'}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  },
);
